<template>
  <b>{{ display }}</b>
</template>
<script>
export default {
  name: 'DisplayResult',
  props: {
    result: {
      type: [Number, String],
      default: ''
    }
  },
  computed: {
    display() {
      return this.result
    }
  }
}
</script>
